import { configureTheme } from "toolcraft-design";

export function applyPoeTheme(): void {
  configureTheme({ brand: "purple", label: "Poe" });
}
